import { Page } from "@iq/models";

function Projects(){
    return(
        <Page>
        </Page>
    )
}

export default Projects;
